import Vue from 'vue'
import Router from 'vue-router'

import head from '@/components/head/index'
import bottom from '@/components/bottom/index'

import index from '@/view/index'
import security from '@/view/security/index'
import aboutUs from '@/view/aboutUs/index'
import helpCenter from '@/view/helpCenter/index'
import toDown from '@/view/toDown/index'
Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/head',
      name: 'head',
      component: head
    },
    {
      path: '/bottom',
      name: 'bottom',
      component: bottom
    },
    {
      path: '/security',
      name: 'security',
      component: security
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/helpCenter',
      name: 'helpCenter',
      component: helpCenter
    },
    {
      path: '/toDown',
      name: 'toDown',
      component: toDown
    }
  ],
  scrollBehavior(to,from,savedPosition){if(savedPosition){
    return savedPosition
    } else {
    return {x:0,y:0 }}}

  
})



// WEBPACK FOOTER //
// ./src/router/index.js